import React from 'react'
import { Image } from 'antd-mobile-v5'
import { useSelector } from 'react-redux'
import { getUserInfo } from '../../reducers/selectors'

import './CertShow.css'
import { finalImagePath } from '../../services/utilities'
import { strToBool, UClick } from '../common/utils'
import { useHistory } from 'react-router-dom'
import { isMainlandUser } from '../../utils/user'

// WZZ dsd has its own style, hide ecard name
const hideEcardName = (ecard) => !ecard || (ecard.certificationNumber === 58 && ecard.storeNumber === 23724)
const BTN_TEXT = {
  BUY_CARD: '点击获取精美卡面',
  VIEW_DETAIL: '点击查看详情',
}
const CardButton = ({ from, gotoDetail, visitStatus }) => {
  const { userInfo } = useSelector((state) => ({
    userInfo: getUserInfo(state),
  }))
  const { push } = useHistory()
  const firseVisit = strToBool(visitStatus)
  const isMainland = isMainlandUser(userInfo)
  const shouldShowBuyCardBtn = firseVisit && isMainland
  const shouldShowDetailBtn = !shouldShowBuyCardBtn && !!from

  const handleBuyCard = () => {
    UClick('clickBuyCardsGroupBCHNA2502')
    setTimeout(() => {
      push('/buy_cards')
    }, 800)
  }

  const handleViewDetail = () => {
    UClick('clickDetailCardsGroupBCHNA2502')
    setTimeout(() => {
      gotoDetail('Btn')
    }, 800)
  }

  return (
    <>
      {/* 展示购买卡面按钮 */}
      {shouldShowBuyCardBtn && (
        <div className="diver_card_btn" onClick={handleBuyCard}>
          {BTN_TEXT.BUY_CARD}
        </div>
      )}

      {/* 展示查看详情按钮 */}
      {shouldShowDetailBtn && (
        <div className="diver_card_btn" onClick={handleViewDetail}>
          {BTN_TEXT.VIEW_DETAIL}
        </div>
      )}
    </>
  )
}

const CardImageShow = ({ path, cert, from, group, visitStatus }, ref) => {
  const { push } = useHistory()
  const cardName = cert.cardTextDTOS || cert.certificationName || cert.credentialName
  const gotoDetail = () => {
    UClick('ToEcardDetailPage')
    let url =
      cert.type === 'CREDENTIAL'
        ? `/cert/credential/${encodeURIComponent(cert.uniqueId)}`
        : `/cert/certificate/${cert.studentNumber}`

    const path = document.location.pathname
    if (path === '/members' || path === '/ecards') {
      url += '?no_nav'
    }
    push(url)
  }

  return (
    <div className={`diver_card`}>
      {!hideEcardName(cert) && (
        <div className="diver_card__bd" onClick={() => gotoDetail('Card')}>
          {cardName instanceof Array ? (
            cardName.map((item) => <h4 key={item.cardTextLine}>{item.cardTextLine}</h4>)
          ) : (
            <h4>{cardName}</h4>
          )}
        </div>
      )}
      <div className="diver_card__bg" onClick={() => gotoDetail('Card')}>
        <Image src={finalImagePath(cert, path)} lazy />
      </div>
      <CardButton from={from} gotoDetail={gotoDetail} visitStatus={visitStatus} />
      {/* {from && <div className="diver_card_btn" onClick={() => gotoDetail('Btn')}>点击查看详情</div>}  */}
    </div>
  )
}

export default CardImageShow
